<div class="jumbotron text-center" [ngStyle]="banner">
  <div id="search-container" class=" search-container-glass col-11 col-md-9 col-lg-8 col-xl-7">
    <h2 class="text-white banner-title">{{ "BookSearch" | translate }}</h2>

    <form class="Bg-Search mb-4" [formGroup]="qsearchForm" (clickOutside)="resetAutoComplete()">
      <div class="dropdown">
        <button id="inputState" class="btn dropdown-toggle dropdown-toggle-custom" type="button"
          data-bs-toggle="dropdown" aria-expanded="false">
          <i class="bi bi-filter-circle me-1 text-primary"></i>
          <span>{{ inputState }}</span>
        </button>
        <ul class="dropdown-menu shadow-lg border-0 rounded-4 p-2">
          <li><a class="dropdown-item rounded-3" role="button" (click)="SearchOption('KEYWORD', 'Keyword')">Keyword</a>
          </li>
          <li><a class="dropdown-item rounded-3" role="button" (click)="SearchOption('TITLE', 'Title')">Title</a></li>
          <li><a class="dropdown-item rounded-3" role="button" (click)="SearchOption('AUTHOR', 'Author')">Author</a>
          </li>
          <li><a class="dropdown-item rounded-3" role="button" (click)="SearchOption('SUBJECT', 'Subject')">Subject</a>
          </li>
          <li><a class="dropdown-item rounded-3" role="button"
              (click)="SearchOption('PUBLISHER', 'Publisher')">Publisher</a></li>
          <li><a class="dropdown-item rounded-3" role="button"
              (click)="SearchOption('JOURNALTITLE', 'Journal')">Journal</a></li>
          <li><a class="dropdown-item rounded-3" role="button" (click)="SearchOption('CALLNUMBER', 'Call number')">Call
              number</a></li>
          <li><a class="dropdown-item rounded-3" role="button"
              (click)="SearchOption('ISBNISSN', 'ISBN/ISSN')">ISBN/ISSN</a></li>
        </ul>
      </div>

      <input type="text" class="form-control border-0 bg-transparent px-3" placeholder="{{ 'Search' | translate }}..."
        formControlName="textSearch" id="TextQSearch" [ngbTypeahead]="searchTypeahead" container="body"
        [popupClass]="'dropdown-autocomplete shadow-lg'" (selectItem)="onSelectItem($event)" [focusFirst]="false"
        (keydown.enter)="search(); $event.preventDefault()" autocomplete="off" />

      <button class="btn search-icon-btn" type="button" (click)="search()">
        <i class="bi bi-search"></i>
      </button>

    </form>

    <div class="d-flex flex-wrap gap-4 justify-content-center mt-3">
      <a class="banner-link" [routerLink]="['/search/alphabetic']">
        <i class="bi bi-fonts"></i>{{ "AlphabeticallySearch" | translate }}
      </a>
      <a class="banner-link" [routerLink]="['/search/advance']">
        <i class="bi bi-sliders"></i>{{ "AdvancedSearch" | translate }}
      </a>
      <a *ngIf="flagOpencurriculum" class="banner-link" [routerLink]="['/search/curriculum']">
        <i class="bi bi-mortarboard"></i>{{ "Search by faculty" | translate }}
      </a>
    </div>
  </div>
</div>

<div class="container container-walai">
  <!-- New Arrivals -->
  <section class="mb-5 pb-5 mt-5 pt-5">
    <div class="d-flex justify-content-between align-items-end mb-4">
      <div>
        <h1 class="h1-main">{{ "NewArrivals" | translate }}</h1>
        <p class="p-main mb-0">{{ "NewArrivalsDetail" | translate }}</p>
      </div>
      <button type="button" class="btn btn-walai px-4 py-2 rounded-pill" data-bs-toggle="modal"
        data-bs-target="#newbookModal">
        {{ "SeeAll" | translate }} <i class="bi bi-arrow-right ms-1"></i>
      </button>
    </div>

    <div class="row g-4 row-cols-2 row-cols-md-4 row-cols-lg-6">
      <div class="col" *ngFor="let b of bookListNew | slice:0:6">
        <div class="h-100 d-flex flex-column">
          <div class="DivBookCover">
            <a [routerLink]="['/bibitem']" [queryParams]="{bibid: b.BIBID}" class="text-decoration-none h-100 d-block">
              <app-book-cover-share [bookCoverURL]="b.bookcoverurl" [id]="b.BIBID" [cssStyle]="'img-fluid w-100 h-100'"
                [title]="b.TITLESHOT"></app-book-cover-share>
            </a>
          </div>
          <a class="a-walai-book-card-view text-center" [routerLink]="['/bibitem']" [queryParams]="{bibid: b.BIBID}">{{
            b.TITLESHOT }}</a>
          <span class="author-text-card-view text-center">{{ b.AUTHOR }}</span>
        </div>
      </div>
    </div>
  </section>

  <!-- Most Popular -->
  <section class="mb-5 pb-5">
    <div class="d-flex justify-content-between align-items-end mb-4">
      <div>
        <h1 class="h1-main">{{ "MostPopular" | translate }}</h1>
        <p class="p-main mb-0">{{ "Popular books, have you tried reading yet?" | translate }}</p>
      </div>
      <button type="button" class="btn btn-walai px-4 py-2 rounded-pill" data-bs-toggle="modal"
        data-bs-target="#toppickModal">
        {{ "SeeAll" | translate }} <i class="bi bi-arrow-right ms-1"></i>
      </button>
    </div>

    <div class="row g-4 row-cols-2 row-cols-md-4 row-cols-lg-6">
      <div class="col" *ngFor="let b of bookListTopPick | slice:0:6">
        <div class="h-100 d-flex flex-column">
          <div class="DivBookCover">
            <a [routerLink]="['/bibitem']" [queryParams]="{bibid: b.BIBID}" class="text-decoration-none h-100 d-block">
              <app-book-cover-share [bookCoverURL]="b.bookcoverurl" [id]="b.BIBID" [cssStyle]="'img-fluid w-100 h-100'"
                [title]="b.TITLESHOT"></app-book-cover-share>
            </a>
          </div>
          <a class="a-walai-book-card-view text-center" [routerLink]="['/bibitem']" [queryParams]="{bibid: b.BIBID}">{{
            b.TITLESHOT }}</a>
          <span class="author-text-card-view text-center">{{ b.AUTHOR }}</span>
        </div>
      </div>
    </div>
  </section>

  <!-- Top View -->
  <section class="mb-5 pb-5">
    <div class="d-flex justify-content-between align-items-end mb-4">
      <div>
        <h1 class="h1-main">{{ "TopView" | translate }}</h1>
        <p class="p-main mb-0">{{ "Top view, have you tried reading yet?" | translate }}</p>
      </div>
      <button type="button" class="btn btn-walai px-4 py-2 rounded-pill" data-bs-toggle="modal"
        data-bs-target="#topviewModal">
        {{ "SeeAll" | translate }} <i class="bi bi-arrow-right ms-1"></i>
      </button>
    </div>

    <div class="row g-4 row-cols-2 row-cols-md-4 row-cols-lg-6">
      <div class="col" *ngFor="let b of bookListTopView | slice:0:6">
        <div class="h-100 d-flex flex-column">
          <div class="DivBookCover">
            <a [routerLink]="['/bibitem']" [queryParams]="{bibid: b.BIBID}" class="text-decoration-none h-100 d-block">
              <app-book-cover-share [bookCoverURL]="b.bookcoverurl" [id]="b.BIBID" [cssStyle]="'img-fluid w-100 h-100'"
                [title]="b.TITLESHOT"></app-book-cover-share>
            </a>
          </div>
          <a class="a-walai-book-card-view text-center" [routerLink]="['/bibitem']" [queryParams]="{bibid: b.BIBID}">{{
            b.TITLESHOT }}</a>
          <span class="author-text-card-view text-center">{{ b.AUTHOR }}</span>
        </div>
      </div>
    </div>
  </section>

  <!-- Librarian Suggest -->
  <section class="mb-5 pb-5">
    <div class="d-flex justify-content-between align-items-end mb-4">
      <div>
        <h1 class="h1-main">{{ "Librarian Suggest" | translate }}</h1>
        <p class="p-main mb-0">{{ "Librarian suggest, have you tried reading yet?" | translate }}</p>
      </div>
      <button type="button" class="btn btn-walai px-4 py-2 rounded-pill" data-bs-toggle="modal"
        data-bs-target="#LibSuggestModal">
        {{ "SeeAll" | translate }} <i class="bi bi-arrow-right ms-1"></i>
      </button>
    </div>

    <div class="row g-4 row-cols-2 row-cols-md-4 row-cols-lg-6">
      <div class="col" *ngFor="let b of bookListLibSuggest | slice:0:6">
        <div class="h-100 d-flex flex-column">
          <div class="DivBookCover">
            <a [routerLink]="['/bibitem']" [queryParams]="{bibid: b.BIBID}" class="text-decoration-none h-100 d-block">
              <app-book-cover-share [bookCoverURL]="b.bookcoverurl" [id]="b.BIBID" [cssStyle]="'img-fluid w-100 h-100'"
                [title]="b.TITLESHOT"></app-book-cover-share>
            </a>
          </div>
          <a class="a-walai-book-card-view text-center" [routerLink]="['/bibitem']" [queryParams]="{bibid: b.BIBID}">{{
            b.TITLESHOT }}</a>
          <span class="author-text-card-view text-center">{{ b.AUTHOR }}</span>
        </div>
      </div>
    </div>
  </section>

  <!-- Browsing Category -->
  <section class="mb-5 pb-5" *ngIf="categorys.length > 0">
    <div class="d-flex justify-content-between align-items-end mb-4">
      <div>
        <h1 class="h1-main">{{ "BrowsingCategory" | translate }}</h1>
        <p class="p-main mb-0">{{ "BrowsingCategorySub" | translate }}</p>
      </div>
      <button type="button" class="btn btn-walai px-4 py-2 rounded-pill" data-bs-toggle="modal"
        data-bs-target="#BrowsingCategory">
        {{ "SeeAll" | translate }} <i class="bi bi-arrow-right ms-1"></i>
      </button>
    </div>

    <div class="row g-4 row-cols-1 row-cols-md-3">
      <div class="col" *ngFor="let cat of categorys9; let i = index">

        <div class="category-card">
          <div class="category-media">
            <img [src]="cat.CATIMG" (error)="imagerror($event)" class="category-img" alt="{{ cat.CATNAMETHAI }}" />
            <div class="category-glass-badge rounded-pill  border rounded-4 bg-white shadow-sm text-dark">
              <i class="bi bi-collection me-1"></i> {{ cat.COUNT }} Items
            </div>
          </div>
          <div class="category-content">
            <h5 class="category-title">{{ cat.CATNAMETHAI }}</h5>
            <h6 class="category-subtitle">({{ cat.CATNAMEENG }})</h6>
            <p class="category-desc">{{ cat.DESCRIPTION }}</p>
            <a [href]="'subcategory?cateid=' + cat.CATEID" class="btn-category">
              Browse Categories <i class="bi bi-chevron-right small"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <app-tag-cloud></app-tag-cloud>

  <!-- Searching Tools -->
  <section class="mt-5 pt-4" *ngIf="searchtools.length > 0">
    <h1 class="h1-main mb-4">Searching Tools</h1>
    <div class="row g-3">
      <div class="col-md-4" *ngFor="let st of searchtools">
        <a [href]="st.IMG_LINKTO" target="_blank"
          class="d-flex align-items-center p-3 border rounded-4 bg-white shadow-sm text-decoration-none hover-lift">
          <img [src]="st.IMG_URL" onError="this.src='assets/images/bookcover/noimage.jpg'" class="rounded me-3"
            style="width: 48px; height: 48px; object-fit: contain;" alt="{{st.IMG_DESC}}">
          <span class="fw-bold text-dark">{{st.IMG_DESC}}</span>
        </a>
      </div>
    </div>
  </section>

  <!-- Educational Resources -->
  <section class="mt-5 pt-4 mb-5" *ngIf="EducationalResources.length > 0">
    <h1 class="h1-main mb-4">Educational Resources</h1>
    <div class="d-flex flex-wrap gap-4 align-items-center">
      <div *ngFor="let edu of EducationalResources" class="hover-scale">
        <a [href]="edu.IMG_LINKTO" target="_blank" [title]="edu.IMG_DESC">
          <img [src]="edu.IMG_URL" class="img-fluid rounded-3 shadow-sm" style="max-height: 80px; width: auto;"
            onError="this.src='assets/images/no-img.jpg'" alt="{{edu.IMG_DESC}}">
        </a>
      </div>
    </div>
  </section>

  <!-- Modals -->
  <div class="modal fade" id="newbookModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content border-0 rounded-5 shadow-2xl">
        <div class="modal-header border-0 pb-0 px-4 pt-4">
          <h5 class="modal-title fw-bold fs-3">{{ "NewArrivals" | translate }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-4">
          <div class="row g-4 row-cols-2 row-cols-md-3 row-cols-lg-5">
            <div class="col" *ngFor="let b of bookListNew">
              <div class="h-100 d-flex flex-column">
                <div class="DivBookCover">
                  <a [routerLink]="['/bibitem']" [queryParams]="{bibid: b.BIBID}"
                    class="text-decoration-none h-100 d-block" data-bs-dismiss="modal">
                    <app-book-cover-share [bookCoverURL]="b.bookcoverurl" [id]="b.BIBID"
                      [cssStyle]="'img-fluid w-100 h-100'" [title]="b.TITLESHOT"></app-book-cover-share>
                  </a>
                </div>
                <a class="a-walai-book-card-view text-center" [routerLink]="['/bibitem']"
                  [queryParams]="{bibid: b.BIBID}" data-bs-dismiss="modal">{{
                  b.TITLESHOT }}</a>
                <span class="author-text-card-view text-center">{{ b.AUTHOR }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="toppickModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content border-0 rounded-5 shadow-2xl">
        <div class="modal-header border-0 pb-0 px-4 pt-4">
          <h5 class="modal-title fw-bold fs-3">{{ "MostPopular" | translate }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-4">
          <div class="row g-4 row-cols-2 row-cols-md-3 row-cols-lg-5">
            <div class="col" *ngFor="let b of bookListTopPick">
              <div class="h-100 d-flex flex-column">
                <div class="DivBookCover">
                  <a [routerLink]="['/bibitem']" [queryParams]="{bibid: b.BIBID}"
                    class="text-decoration-none h-100 d-block" data-bs-dismiss="modal">
                    <app-book-cover-share [bookCoverURL]="b.bookcoverurl" [id]="b.BIBID"
                      [cssStyle]="'img-fluid w-100 h-100 rounded-4'" [title]="b.TITLESHOT"></app-book-cover-share>
                  </a>
                </div>
                <a class="a-walai-book-card-view text-center" [routerLink]="['/bibitem']"
                  [queryParams]="{bibid: b.BIBID}" data-bs-dismiss="modal">{{
                  b.TITLESHOT }}</a>
                <span class="author-text-card-view text-center">{{ b.AUTHOR }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="topviewModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content border-0 rounded-5 shadow-2xl">
        <div class="modal-header border-0 pb-0 px-4 pt-4">
          <h5 class="modal-title fw-bold fs-3">{{ "TopView" | translate }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-4">
          <div class="row g-4 row-cols-2 row-cols-md-3 row-cols-lg-5">
            <div class="col" *ngFor="let b of bookListTopView">
              <div class="h-100 d-flex flex-column">
                <div class="DivBookCover">
                  <a [routerLink]="['/bibitem']" [queryParams]="{bibid: b.BIBID}"
                    class="text-decoration-none h-100 d-block" data-bs-dismiss="modal">
                    <app-book-cover-share [bookCoverURL]="b.bookcoverurl" [id]="b.BIBID"
                      [cssStyle]="'img-fluid w-100 h-100 rounded-4'" [title]="b.TITLESHOT"></app-book-cover-share>
                  </a>
                </div>
                <a class="a-walai-book-card-view text-center" [routerLink]="['/bibitem']"
                  [queryParams]="{bibid: b.BIBID}" data-bs-dismiss="modal">{{
                  b.TITLESHOT }}</a>
                <span class="author-text-card-view text-center">{{ b.AUTHOR }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="LibSuggestModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content border-0 rounded-5 shadow-2xl">
        <div class="modal-header border-0 pb-0 px-4 pt-4">
          <h5 class="modal-title fw-bold fs-3">{{ "Librarian Suggest" | translate }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-4">
          <div class="row g-4 row-cols-2 row-cols-md-3 row-cols-lg-5">
            <div class="col" *ngFor="let b of bookListLibSuggest">
              <div class="h-100 d-flex flex-column">
                <div class="DivBookCover">
                  <a [routerLink]="['/bibitem']" [queryParams]="{bibid: b.BIBID}"
                    class="text-decoration-none h-100 d-block" data-bs-dismiss="modal">
                    <app-book-cover-share [bookCoverURL]="b.bookcoverurl" [id]="b.BIBID"
                      [cssStyle]="'img-fluid w-100 h-100 rounded-4'" [title]="b.TITLESHOT"></app-book-cover-share>
                  </a>
                </div>
                <a class="a-walai-book-card-view text-center" [routerLink]="['/bibitem']"
                  [queryParams]="{bibid: b.BIBID}" data-bs-dismiss="modal">{{
                  b.TITLESHOT }}</a>
                <span class="author-text-card-view text-center">{{ b.AUTHOR }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="BrowsingCategory" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content border-0 rounded-5 shadow-2xl">
        <div class="modal-header border-0 pb-0 px-4 pt-4">
          <h5 class="modal-title fw-bold fs-3">{{ "BrowsingCategory" | translate }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-4">
          <div class="row g-4">
            <div class="col-md-4 col-sm-6" *ngFor="let cat of categorys">
              <div class="category-card h-100">
                <div class="category-media">
                  <img [src]="cat.CATIMG" (error)="imagerror($event)" class="category-img"
                    alt="{{ cat.CATNAMETHAI }}" />
                  <div class="category-glass-badge">
                    <i class="bi bi-collection me-1"></i> {{ cat.COUNT }} Items
                  </div>
                </div>
                <div class="category-content">
                  <h5 class="category-title">{{ cat.CATNAMETHAI }}</h5>
                  <h6 class="category-subtitle">({{ cat.CATNAMEENG }})</h6>
                  <p class="category-desc" *ngIf="cat.DESCRIPTION">{{ cat.DESCRIPTION }}</p>
                  <a [href]="'subcategory?cateid=' + cat.CATEID" class="btn-category" data-bs-dismiss="modal">
                    Browse Categories <i class="bi bi-chevron-right small"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>